/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelAuthArControl.ts                 *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/ar/auth-ar-control";

export class AutogenModelAuthArControl<RowType extends ModelRow> extends Endpoint<RowType, RowAuthArControlFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowAuthArControl extends ModelRow<RowAuthArControlFields> {
	constructor(values?: Partial<RowAuthArControlFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowAuthArControlFields {
	age_period_1: number;
	age_period_1_desc: string;
	age_period_2: number;
	age_period_2_desc: string;
	age_period_3: number;
	age_period_3_desc: string;
	age_period_4: number;
	age_period_4_desc: string;
    rendition_billing: string;
}

